import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { UserContext } from '../utils/UserContext';
import { useContext } from 'react';
import {setLocalStorage, renderServerMessage } from '../utils/utils';
import axios from "../hooks/axios";
import { useState } from 'react';
import { COPY_RIGHT, PROJECT_TITLE, COPY_RIGHT_EMAIL } from '../utils/constants';
import { Grid } from '@mui/material';
import queryString from 'query-string';





function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="mailto:"{...COPY_RIGHT_EMAIL}>
        {COPY_RIGHT}
      </Link>{'-'}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();




export default function ResetPassword( props ) {
    const {userData,setUserData} = useContext(UserContext)
    const [serverMessage,setServerMessage] =useState();


    const params = queryString.parse(window.location.search);


    const validateConfirmPassword = (password,confirmPassword) => {
      return password === confirmPassword;  
    };


    const reload =()=>{
      console.log(props)
      axios.post(`reset-password.php`, {token:params.token}).then((response) => {
          console.log(response.data);
          setServerMessage(renderServerMessage (response.data));

  });
}

  React.useEffect(()=>{
      reload();
  },[])

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
   
    if(!validateConfirmPassword(data.get('password'),data.get('confirmPassword'))){
      var error={};
      error.success = false;
      error.message = "Confirm Password Doesn`t match Password";
      setServerMessage(renderServerMessage (error));

      return;
    }

    axios.post('reset-password.php', {
      password: data.get('password'),
      token : params.token
    }).then((response) => {
      setServerMessage(renderServerMessage (response.data)) 
}).catch(error => {
  setServerMessage(renderServerMessage ({success : false , message : "An Error Has Occured Please Try again"}))
});
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <img src={require('./logo.png')} width="150" />
          <Typography component="h1" variant="h5">
            {PROJECT_TITLE}
          </Typography>
          <Box component="form" onSubmit={handleSubmit}  sx={{ mt: 1 }}>
            {serverMessage}


            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
            />


          <TextField
              margin="normal"
              required
              fullWidth
              name="confirmPassword"
              label="Confirm Password"
              type="password"
              id="confirmPassword"
            />
           
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Reset Password
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="/sign-in" variant="body2">
                 back to login page
                </Link>
              </Grid>
              <Grid item>
                <Link href="/sign-up" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>

          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}